import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { Button, Spinner } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { RESEND_ORDER_RECEIPT } from "../graphql/orderGroup/mutation";

const WARNING = "#B45309";

//* ບິນທີ່ສົ່ງບໍ່ເຖິງລູກຄ້າ: ບອກຮ້ານແຕ່ວ່າສົ່ງບໍ່ສຳເລັດ ບໍ່ບອກສາເຫດ
//*   ສົ່ງ id ຂອງອໍເດີ (order) ຫຼື ບິນ (orderGroup) ອັນໃດອັນໜຶ່ງ
//*   ກົດແລ້ວຍັງບໍ່ສຳເລັດ 2 ເທື່ອ → ໃຫ້ຕິດຕໍ່ທີມງານແທນການກົດຊ້ຳ
const ResendBillButton = ({ order, orderGroup, onSent, showLabel = true }) => {
    const { addToast } = useToasts();
    const [resend, { loading }] = useMutation(RESEND_ORDER_RECEIPT);
    const [contactSupport, setContactSupport] = useState(false);

    const handleResend = async () => {
        if (loading) return;
        try {
            const { data } = await resend({
                variables: { where: order ? { order } : { orderGroup } },
            });
            const result = data?.resendOrderReceipt;
            if (result?.status === "SENT") {
                addToast("ສົ່ງບິນຫາລູກຄ້າແລ້ວ", { appearance: "success", autoDismiss: true });
                if (onSent) onSent();
                return;
            }
            if (result?.status === "IN_PROGRESS") {
                addToast("ກຳລັງສົ່ງບິນນີ້ຢູ່", { appearance: "info", autoDismiss: true });
                return;
            }
            if (result?.contactSupport) setContactSupport(true);
            addToast("ສົ່ງບໍ່ສຳເລັດ", { appearance: "error", autoDismiss: true });
        } catch (error) {
            console.log("resend bill error: ", error);
            addToast("ສົ່ງບໍ່ສຳເລັດ", { appearance: "error", autoDismiss: true });
        }
    };

    return (
        <div
            style={{
                display: "inline-flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                padding: "2px 6px",
                borderRadius: 8,
                background: "#FFF4E5",
                color: WARNING,
                fontSize: 12,
                whiteSpace: "normal",
            }}
        >
            {showLabel && <span>⚠️ ສົ່ງບໍ່ສຳເລັດ</span>}
            {contactSupport ? (
                <span style={{ fontWeight: "bold" }}>ກະລຸນາຕິດຕໍ່ທີມງານ</span>
            ) : (
                <Button
                    size="sm"
                    disabled={loading}
                    onClick={handleResend}
                    style={{
                        background: "transparent",
                        color: WARNING,
                        borderColor: WARNING,
                        padding: "0 6px",
                        fontSize: 12,
                        fontWeight: "bold",
                        borderRadius: 8,
                    }}
                >
                    {loading ? <Spinner animation="border" size="sm" aria-label="resending" /> : "ສົ່ງອີກຄັ້ງ"}
                </Button>
            )}
        </div>
    );
};

export default ResendBillButton;
